// -------------------------------------------------------LIVE-URL-----------------------------------------------------

export const hostname = "http://www.traveloes.com:6500/"; //live
export const hotelhostname = "https://hotelapi.travomint.com";
export const flightHost = "http://13.127.172.138:3001/"; //live
export const flightHostLive = "http://44.224.252.119:3001/"; //live
export const scrapping_Host = "http://13.127.172.138:2500/"; //live
export const gfsBaseURL = "https://vbs.travomint.com/GOOGLE/"; //live

// -------------------------------------------------------LOCAL-URL-----------------------------------------------------
// export const hostname = "http://10.20.1.73:6500/"; //local
// export const hotelhostname = "http://10.20.1.73:2800"; //local
// export const FlightBookingHostname = "http://10.20.1.32:1001"; //local
// export const flightHostLive = "http://10.20.1.57:1001/"; //
// export const scrapping_Host = "http://10.20.1.73:2500/"; //local
// export const gfsBaseURL = "http://10.20.1.86:8128/"; // harshit's local
